<template>
    <div>
        <v-container>
            <v-card-title>
                <v-layout row>
                    <v-dialog v-model="dialog" fullscreen hide-overlay transition="slide-y-transition">
                        <v-btn slot="activator"  @click="dialog = true" color="info">Add User</v-btn>
                        <v-card>
                            <v-toolbar dark>
                                <v-btn icon dark @click="dialog = false">
                                    <v-icon>arrow_back</v-icon>
                                </v-btn>
                                <p style="font-size: 14px;" class="mt-3">Back to users</p>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <add-admin-user v-on:closed="dialog=false"></add-admin-user>
                        </v-card>
                    </v-dialog>
                </v-layout>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="adminUsers" :search="search">
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
                    <td>{{ props.item.email }}</td>
                    <td>{{ props.item.role }}</td>
                    <td>{{ props.item.phone }}</td>
                    <td>{{ props.item.position }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
                <template slot="no-data">
                    <v-alert :value="true" color="error" icon="warning">
                        Sorry, nothing to display here :(
                    </v-alert>
                </template>
                </v-data-table>
        </v-container>
    </div>
</template>
<script>
import Vue from 'vue'
import AddAdminUser from '../components/AddAdminUser'
import db from '../firebase/init.js'
export default {
    name: 'AdminUsers',
    components: {
        AddAdminUser
    },
    data(){
        return {
            search: '',
            headers: [
                { text: 'Name', value: 'name' },
                { text: 'Email', value: 'email' },
                { text: 'Role', value: 'role' },
                { text: 'Phone', value: 'phone' },
                { text: 'Position', value: 'position' }
            ],
            adminUsers: [],
            dialog: false
        }
    },
    methods: {
        viewItem(){
            this.$router.push('/account-view')
        }
    },
    mounted(){
        document.title = "Vaboo Admin Users"
        db.collection('admin-users').onSnapshot(snapshot => {
            this.adminUsers = []
            snapshot.forEach(doc => {
                var adminUser = doc.data()
                this.adminUsers.unshift(adminUser)
            })
        })
    }

}
</script>

<style>

</style>
